import React, { ReactElement } from "react";
import styles from "./DescriptionTextColumn.module.scss";
import { Icon, IconName } from "../Icon/Icon";

export const DescriptionTextColumnTitle: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.title}>{props.children}</div>;
};

export const DescriptionTextColumnLeadIn: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.leadIn}>{props.children}</div>;
};

export const DescriptionTextColumnContentLeft: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.contentLeft}>{props.children}</div>;
};

export const DescriptionTextColumnContentRight: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.contentRight}>{props.children}</div>;
};

export const DescriptionTextColumnContent: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.contentContainer}>{props.children}</div>;
};

export const DescriptionTextColumn: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.descriptionText}>{props.children}</div>;
};

type DescriptionTextColumnIconHighlightsProps = {
  items: {
    key: string;
    icon: IconName;
    label: string | ReactElement;
  }[];
};
export const DescriptionTextColumnIconHighlights: React.FC<
  DescriptionTextColumnIconHighlightsProps
> = ({ items }) => {
  return (
    <ul className={styles.highlights}>
      {items.map((i) => (
        <li className={styles.item} key={i.key}>
          <Icon name={i.icon} padding="inline" size="1.5x" /> {i.label}
        </li>
      ))}
    </ul>
  );
};
